import React, { useState } from "react";
import API from "../../ApiService/ApiService";
import Context from "./index";
const DNBMDV2Provider = (props) => {
  const api = new API();
  const [DNBMDSV2SpecilityFilter, setDNBMDSV2SpecilityFilter] = useState({
    name: "",
    page: 1,
    limit: 20,
  });
  const [DNBMDSV2SpecilityList, setDNBMDSV2SpecilityList] = useState([]);
  const [DNBMDSV2SpecilityLoader, setDNBMDSV2SpecilityLoader] = useState(false);
  const [DNBMDSV2TopicFilter, setDNBMDSV2TopicFilter] = useState({
    name: "",
    page: 1,
    limit: 20,
  });
  const [DNBMDSV2TopicList, setDNBMDSV2TopicList] = useState([]);
  const [DNBMDSV2TopicLoader, setDNBMDSV2TopicLoader] = useState(false);
  const [DNBMDSV2SubTopicFilter, setDNBMDSV2SubTopicFilter] = useState({
    name: "",
    page: 1,
    limit: 20,
  });
  const [DNBMDSV2SubTopicList, setDNBMDSV2SubTopicList] = useState([]);
  const [DNBMDSV2SubTopicLoader, setDNBMDSV2SubTopicLoader] = useState(false);
  const [DNBMDSV2DNBMDSFilter, setDNBMDSV2DNBMDSFilter] = useState({
    name: "",
    page: 1,
    limit: 20,
  });
  const [DNBMDSV2DNBMDSList, setDNBMDSV2DNBMDSList] = useState([]);
  const [DNBMDSV2DNBMDSLoader, setDNBMDSV2DNBMDSLoader] = useState(false);

  const fetchDNBMDSV2Specility = async () => {
    setDNBMDSV2SpecilityLoader(true);
    localStorage.getItem("rxdx_admin_login") &&
      await api.getAll("dnbmd/dnbmd_speciality_list_v2", { ...DNBMDSV2SpecilityFilter }, (err, res) => {
        if (res?.data?.status === 200) {
          setDNBMDSV2SpecilityList(res?.data?.data);
          setDNBMDSV2SpecilityLoader(false);
        } else {
          setDNBMDSV2SpecilityList([]);
          setDNBMDSV2SpecilityLoader(false);
        }
      });
  }

  const fetchDNBMDSV2Topic = async (subcategory_id=null) => {
    if(!subcategory_id) return;
    setDNBMDSV2TopicLoader(true);
    localStorage.getItem("rxdx_admin_login") &&
      await api.getAll("dnbmd/dnbmd_topic_list_v2", { ...DNBMDSV2TopicFilter, subcategory_id }, (err, res) => {
        if (res?.data?.status === 200) {
          setDNBMDSV2TopicList(res?.data?.data);
          setDNBMDSV2TopicLoader(false);
        } else {
          setDNBMDSV2TopicList([]);
          setDNBMDSV2TopicLoader(false);
        }
      });
  }

  const fetchDNBMDSV2SubTopic = async (subject_id=null) => {
    if(!subject_id) return;
    setDNBMDSV2SubTopicLoader(true);
    localStorage.getItem("rxdx_admin_login") &&
      await api.getAll("dnbmd/dnbmd_subtopic_list_v2", { ...DNBMDSV2SubTopicFilter, subject_id }, (err, res) => {
        if (res?.data?.status === 200) {
          setDNBMDSV2SubTopicList(res?.data?.data);
          setDNBMDSV2SubTopicLoader(false);
        } else {
          setDNBMDSV2SubTopicList([]);
          setDNBMDSV2SubTopicLoader(false);
        }
      });
  }

  const fetchDNBMDSV2DNBMDS = async (topic_id=null) => {
    if(!topic_id) return;
    setDNBMDSV2DNBMDSLoader(true);
    localStorage.getItem("rxdx_admin_login") &&
      await api.getAll("dnbmd/dnbmd_notes_list_v2", { ...DNBMDSV2DNBMDSFilter, topic_id }, (err, res) => {
        if (res?.data?.status === 200) {
          setDNBMDSV2DNBMDSList(res?.data?.data);
          setDNBMDSV2DNBMDSLoader(false);
        } else {
          setDNBMDSV2DNBMDSList([]);
          setDNBMDSV2DNBMDSLoader(false);
        }
      });
  }

  return (
    <Context.Provider
      value={{
        ...props,
        DNBMDSV2SpecilityFilter, setDNBMDSV2SpecilityFilter,
        DNBMDSV2SpecilityList, setDNBMDSV2SpecilityList,
        DNBMDSV2SpecilityLoader, setDNBMDSV2SpecilityLoader,
        fetchDNBMDSV2Specility,
        DNBMDSV2TopicFilter, setDNBMDSV2TopicFilter,
        DNBMDSV2TopicList, setDNBMDSV2TopicList,
        DNBMDSV2TopicLoader, setDNBMDSV2TopicLoader,
        fetchDNBMDSV2Topic,
        DNBMDSV2SubTopicFilter, setDNBMDSV2SubTopicFilter,
        DNBMDSV2SubTopicList, setDNBMDSV2SubTopicList,
        DNBMDSV2SubTopicLoader, setDNBMDSV2SubTopicLoader,
        fetchDNBMDSV2SubTopic,
        DNBMDSV2DNBMDSFilter, setDNBMDSV2DNBMDSFilter,
        DNBMDSV2DNBMDSList, setDNBMDSV2DNBMDSList,
        DNBMDSV2DNBMDSLoader, setDNBMDSV2DNBMDSLoader,
        fetchDNBMDSV2DNBMDS,
      }}
    >
      {props.children}
    </Context.Provider>
  );
};

export default DNBMDV2Provider;
